import { atom } from "recoil";

const registerUserAtom = atom({
  key: "registerUserState",
  default: {},
});

export default registerUserAtom;
